import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Home from './pages/Home/Home';
import Calculator from './pages/Calculator/Calculator';
import Header from './blocks/Header';
import Footer from './blocks/Footer';
import { HelmetProvider } from 'react-helmet-async';
import About from './pages/About/About';
import DecommissionInfo from './blocks/DecommissionInfo';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <DecommissionInfo />
        <Header />
        <Switch>
          <Route path="/kalkulacka">
            <Calculator />
          </Route>
          <Route path="/projekt">
            <About />
          </Route>
          <Route path="/">
            <Home />
          </Route>
        </Switch>
        <Footer />
      </Router>
    </HelmetProvider>
  );
}

export default App;
